import { PALETTE, MIC_TYPE_LABEL, minutesToHHMM, type Presenter } from '@micplot/shared';
import Avatar from './Avatar';

interface Props {
  presenter: Presenter;
  draggable?: boolean;
  selected?: boolean;
  onSelect?: () => void;
  onEdit?: (id: string) => void;
}

export default function PresenterCard({
  presenter, draggable = true, selected, onSelect, onEdit,
}: Props) {
  const span = presenter.slots.length
    ? `${minutesToHHMM(presenter.slots[0]!.start)}–${minutesToHHMM(presenter.slots.at(-1)!.end)}`
    : 'no times set';

  return (
    <div
      className={`pcard${selected ? ' selected' : ''}`}
      draggable={draggable}
      // Selectable by keyboard so the board is usable without a mouse.
      role={onSelect ? 'button' : undefined}
      tabIndex={onSelect ? 0 : undefined}
      aria-pressed={onSelect ? !!selected : undefined}
      onClick={onSelect}
      onKeyDown={e => {
        if (onSelect && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onSelect();
        }
      }}
      onDragStart={e => {
        e.dataTransfer.setData('text/presenter-id', presenter.id);
        e.dataTransfer.effectAllowed = 'move';
      }}
    >
      <span className="swatch" style={{ background: PALETTE[presenter.color % PALETTE.length] }} />
      {/* Face and name travel together, so a narrow screen can give the pair
          a whole row rather than truncating both. */}
      <span className="pcard-who">
        <Avatar presenter={presenter} size={30} />
        <span className="pcard-name">
          {presenter.name}
          {(presenter.characterName || presenter.title) && (
            <div className="pcard-title">
              {presenter.characterName || presenter.title}
            </div>
          )}
        </span>
      </span>
      <span className="chip" title={MIC_TYPE_LABEL[presenter.micPreference]}>
        {presenter.micPreference}
      </span>
      <span className="chip" title="On-stage window">{span}</span>
      {onEdit && (
        <button className="btn sm" onClick={() => onEdit(presenter.id)} aria-label="Edit presenter">
          Edit
        </button>
      )}
    </div>
  );
}
